var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cloudShare"},[_c('div',{staticClass:"line"}),_c('img',{attrs:{"src":require("@/../public/images/loading.png"),"alt":""}}),_c('div',{staticClass:"zhen_6"},[_vm._v(_vm._s(_vm._lang[_vm.$route.query.type].zhen_6))])])}
var staticRenderFns = []

export { render, staticRenderFns }